import React from "react";
import { Box, Typography, Grid } from "@mui/material";
import { CurrencyRupee, Handshake } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import pieChart from "../assets/landing/icons/lucide-pie-chart-icon.svg";

const Introduction = () => {
  const { t } = useTranslation();
  const benefits = [
    {
      icon: <CurrencyRupee sx={{ color: "#54BD95" }} />,
      title: t("Higher Farmer Profitability"),
      description: t("Unlock new revenue streams & reduce input costs"),
    },
    {
      icon: <img src={pieChart} alt="pie-chart" />,
      title: t("Sustainable Growth"),
      description: t(
        "Drive environmental responsibility with water-efficient & eco-friendly practices."
      ),
    },
    {
      icon: <Handshake style={{ color: "#54BD95" }} />,
      title: t("Industry Partnerships"),
      description: t(
        "Collaborate with governments, agribusinesses, and research institutions for large-scale impact."
      ),
    },
  ];

  return (
    <Box
      sx={{
        py: 8,
        backgroundColor: "#F9F8FE",
        m: 0,
      }}
    >
      <Box sx={{ maxWidth: "1180px", margin: "auto", padding: "0 24px" }}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={6.5}>
            <Typography
              sx={{ fontWeight: "600", fontSize: "50px" }}
              gutterBottom
            >
              {t("Introduction")}
            </Typography>
            <Typography variant="body1" paragraph sx={{ color: "#A6A6A6" }}>
              {t(
                "The global agriculture industry is at a crossroads—balancing productivity with sustainability is more challenging than ever. Excessive reliance on chemical inputs, unpredictable weather patterns, and fragmented supply chains continue to threaten food security and farmer livelihoods. With over 80% of farmers operating on small and marginal landholdings, access to technology, market intelligence, and sustainable practices remains a critical barrier."
              )}
            </Typography>
            <Typography variant="body1" sx={{ color: "#A6A6A6" }}>
              {t(
                "At ASQI, we saw an opportunity to disrupt this landscape—bridging the gap between technology, sustainability, and profitability for farmers and agribusinesses. FarmApp is not just a platform; it's a revolution."
              )}
            </Typography>
          </Grid>

          {/* Right side - Benefits cards */}
          <Grid item xs={12} md={5.5}>
            <Box sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid container spacing={3}>
                {benefits.map((benefit, index) => (
                  <Grid item xs={12} key={index}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 3,
                      }}
                    >
                      <Box
                        sx={{
                          backgroundColor: "#FFFFFF",
                          width: "64px",
                          height: "64px",
                          minWidth: "64px",
                          minHeight: "64px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        {benefit.icon}
                      </Box>
                      <Box>
                        <Typography
                          fontSize={"1.75rem"}
                          component="h3"
                          gutterBottom
                          fontWeight="bold"
                        >
                          {benefit.title}
                        </Typography>
                        <Typography fontSize={"1.125rem"} color="#A6A6A6">
                          {benefit.description}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default Introduction;
